<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
//import { Button } from "@/components/ui/button";
import RegionHeader from "@/components/region/RegionHeader.vue";
import PlansGrid from "@/components/region/PlansGrid.vue";
import PaginationControls from "@/components/region/PaginationControls.vue";
import { usePlans } from "@/composables/usePlans";
import { usePagination } from "@/composables/usePagination";
import { useResponsiveItems } from "@/composables/useResponsiveItems";
//import { useCheckout } from "@/composables/useCheckout";
import appleLogo from "/logos/svg/apple-logo.svg";

const route = useRoute();
const regionCode = ref<string>(route.params.regionCode as string);
const selectedPlan = ref<string>("");

const { plans, regionName, loading, fetchPlans } = usePlans(regionCode.value);
const { itemsPerPage } = useResponsiveItems();
const {
  paginatedItems: paginatedPlans,
  currentPage,
  totalPages,
  canGoPrev,
  canGoNext,
  nextPage,
  prevPage,
} = usePagination(plans, itemsPerPage);
//const { goToCheckout } = useCheckout(regionCode.value);

onMounted(() => {
  fetchPlans();
});
</script>

<template>
  <div class="max-w-5xl mx-auto py-24 px-4">
    <div class="max-w-4xl mx-auto">
      <RegionHeader
        :region-code="regionCode"
        :region-name="regionName"
        :loading="loading"
      />

      <PlansGrid
        v-model:selected-plan="selectedPlan"
        :plans="paginatedPlans"
        :loading="loading"
        :items-per-page="itemsPerPage"
      />

      <PaginationControls
        :current-page="currentPage"
        :total-pages="totalPages"
        :can-go-prev="canGoPrev"
        :can-go-next="canGoNext"
        :loading="loading"
        @prev="prevPage"
        @next="nextPage"
      />

      <div class="flex justify-center">
        <!--<Button
          :disabled="!selectedPlan"
          class="min-w-[200px]"
          @click="goToCheckout(selectedPlan)"
        >
          Go to Checkout
        </Button>-->
        <a
          href="https://apps.apple.com/us/app/jittr-esim-global-data/id6753299070"
          class="transition-all duration-300 ease-out hover:scale-102 hover:shadow-xl hover:brightness-110 active:scale-100 shadow-[inset_4px_4px_8px_rgba(0,0,0,0.1),inset_-4px_-4px_8px_rgba(0,0,0,0.1)] cursor-pointer bg-white text-black rounded-lg flex items-center gap-2 px-4 py-2"
        >
          <img :src="appleLogo" alt="apple-logo" class="w-6 h-6" />
            App Store
        </a>
      </div>
    </div>
  </div>
</template>
